import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { blogs as allBlogs } from "../data/blog";

const Blogs = () => {
  const sortedBlogs = [...allBlogs].sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );
  const featuredBlog = sortedBlogs.find((b) => b.featured) || sortedBlogs[0];

  return (
    <section
      id="blogs"
      className="max-w-5xl mx-auto px-6 md:px-8 lg:px-10 pt-6 md:pt-10 pb-16 md:pb-20 scroll-mt-24">

      {/* === Featured Blog Card === */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="relative rounded-2xl bg-gradient-to-br from-[#141820] to-[#0b0d14]
                   border border-white/10 p-6 md:p-8 mb-8
                   hover:border-brand-teal/30 hover:shadow-[0_0_25px_rgba(0,224,183,0.15)]
                   transition-all duration-500"
      >
        {/* Subtle background glow */}
        <div className="absolute inset-0 bg-gradient-to-br from-brand-teal/5 to-brand-blue/5 blur-2xl -z-10 rounded-2xl" />

        <p className="text-xs uppercase tracking-wider text-brand-teal mb-2">
          Featured Brew ☕
        </p>
        <h3 className="text-xl md:text-2xl font-semibold text-white mb-2 leading-tight">
          {featuredBlog.title}
        </h3>
        <p className="text-slate-400 text-sm mb-3">{featuredBlog.date}</p>
        <p className="text-slate-300 text-sm md:text-base leading-relaxed mb-5">
          {featuredBlog.excerpt}
        </p>

        <Link
          to={`/blog/${featuredBlog.slug}`}
          className="inline-block px-5 py-2 rounded-full bg-gradient-to-r
                     from-[#00e0b7] to-[#4b5fff] text-white text-sm font-semibold
                     hover:shadow-[0_0_18px_rgba(0,224,183,0.25)] hover:-translate-y-0.5 transition"
        >
          Read Full Brew →
        </Link>
      </motion.div>

      {/* === View All Button === */}
      <div className="flex justify-center mt-8">
        <Link
          to="/blog"
          className="px-6 py-2 rounded-full bg-gradient-to-r from-[#00e0b7] to-[#4b5fff]
                     text-white font-semibold hover:shadow-[0_0_18px_rgba(0,224,183,0.25)]
                     hover:-translate-y-0.5 transition"
        >
          View All Blogs →
        </Link>
      </div>
    </section>
  );
};

export default Blogs;
